module.exports = __webpack_public_path__ + "img/followAlongDropDown.39b7f0f9.png";